"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalErrorWatcher = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Modal_1 = require("../widget/Modal/Modal");
var ServerErrorMain_1 = require("../main/ServerErrorMain/ServerErrorMain");
var emotion_1 = require("emotion");
var appStylesBase_1 = require("../../styles/appStylesBase");
var react_redux_1 = require("react-redux");
var react_redux_2 = require("react-redux");
var envConfigBase_1 = require("../../envConfig/envConfigBase");
var sentrySdk_1 = require("../../sdks/sentry/sentrySdk");
var SentrySeverity_1 = require("../../sdks/sentry/SentrySeverity");
var description = 'ModalErrorWatcher';
var ModalErrorWatcher = function (_a) {
    var homePathname = _a.homePathname;
    var dispatch = (0, react_redux_2.useDispatch)();
    var alertMessage = (0, react_redux_1.useSelector)(function (state) {
        return state.alertMessage || undefined;
    });
    var message = alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.message;
    var type = alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.type;
    var status = alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.status;
    var show = (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.location) === 'modal' && type === 'error';
    var showDetails = (0, envConfigBase_1.envConfigBase)().environment !== 'production';
    if (!show) {
        return null;
    }
    (0, sentrySdk_1.sentrySdk)().captureMessage("".concat(description, " shown"), SentrySeverity_1.SentrySeverity.Critical);
    var details = "status: ".concat(status, " | type: ").concat(type, " | message: ").concat(message);
    return (react_1.default.createElement(Modal_1.Modal, { visible: true, onCancel: function () {
            dispatch({
                type: 'UNSET_ALERT_MESSAGE',
                description: description,
            });
        } },
        react_1.default.createElement(ServerErrorMain_1.ServerErrorMain, { homePathname: homePathname, onClick: function () {
                dispatch({
                    type: 'UNSET_ALERT_MESSAGE',
                    description: description,
                });
            } }),
        showDetails && (react_1.default.createElement("p", { className: (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n            margin-top: ", ";\n          "], ["\n            margin-top: ", ";\n          "])), (0, appStylesBase_1.appStylesBase)().spacing.medium) }, details))));
};
exports.ModalErrorWatcher = ModalErrorWatcher;
var templateObject_1;
